export const fillDates = (startOffset = 0, count = 7) => {
    const days = [];
    for (let i = 0; i < count; i++) {
        const d = new Date();
        d.setDate(d.getDate() + startOffset + i);
        days.push(d);
    }
    return days;
};
